import chunk from 'lodash/chunk';

import {
  CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER,
  ENTITIES_PER_PAGE
} from '../constants/common';

import {
  CreateNewProfilesEntity,
  CreateNewProfilesModalState
} from '../types/CreateNewProfiles.type';
import type { Pagination } from 'types';

export const getPageEntities = (
  page: number,
  entities: Array<CreateNewProfilesEntity>
): Array<CreateNewProfilesEntity> => chunk(entities, ENTITIES_PER_PAGE)[page - 1];

export const getPagination = (
  state: CreateNewProfilesModalState
): Pagination => {
  if (
    state.type === CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER
    && state.data?.type === 'successful-upload'
  ) {
    const { entities, page } = state.data;
    const totalPages = chunk(entities, ENTITIES_PER_PAGE).length;

    return {
      currentPage: page,
      itemsPerPage: ENTITIES_PER_PAGE,
      pagesTotal: totalPages,
      itemsCurrentPage: getPageEntities(page, entities).length,
      links: {
        prev: page > 1 ? 'prev' : undefined,
        next: page < totalPages ? 'next' : undefined
      }
    };
  }

  return {
    currentPage: 0,
    itemsPerPage: 0,
    pagesTotal: 0,
    itemsCurrentPage: 0
  };
};
